import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/bond-convexity-calculator',
  component: () => import('../../routes/BondConvexityCalculator.svelte'),
  card: {
    id: 'bond-convexity-calculator',
    title: 'Bond Convexity Calculator',
    description: 'Calculate bond duration, convexity, and price sensitivity to interest rate changes. See how convexity improves returns beyond duration alone.',
    icon: 'linear_scale',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/bond-convexity-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Bond Convexity Calculator – Duration, Convexity & Interest Rate Sensitivity',
    description: 'Free bond convexity calculator to calculate modified duration, Macaulay duration, and convexity. See how bond prices respond to interest rate changes and why convexity matters for fixed-income investors.',
  },
};

export default meta;
